// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import stat from '@infrastructure/shared/constant'
// ** Axios Imports
import axios from 'axios'

export const getGrade = createAsyncThunk('appLaporan/getGrade', async params => {
  const response = await axios.get(stat.URL_GRADE_ALL, { params })
  return {
    data: response.data
  }
})

export const getGradeKelas = createAsyncThunk('appLaporan/getGradeKelas', async (kode_grade, {params, getState })  => {
  const response = await axios.get(stat.URL_KELAS + kode_grade, { params })
  console.log('current state:', getState())
  return response.data
})


export const getSiswaList = createAsyncThunk('appLaporan/getSiswaList', async (id_kelas, {params})  => {
  const add_url = "list/kelas/"
  const response = await axios.get(stat.URL_SISWA + add_url + id_kelas, { params })
  return response.data
})


export const appLaporanSlice = createSlice({
  name: 'appLaporan',
  initialState: {
    grade: [],
    statusLoadGrade: null,
    kelas: [],
    idKelas: null,
    statusIdKelas: null,
    kodeGrade: null,
    siswa: [],
    statusSiswa: null,
    // selectedTask: {},
    params: {
      filter: '',
      q: '',
      sort: '',
      tag: ''
    }
  },
  reducers: {
    selectIdKelas: (state, action) => {
      state.idKelas = action.payload
    },
    selectKodeGrade: (state, action) => {
      state.kodeGrade = action.payload
    }
  },
  extraReducers: builder => {
    
    builder.addCase(getGrade.fulfilled, (state, action) => {
      state.grade = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getGradeKelas.pending, (state) => {
      state.statusIdKelas = 'loading'
    })
    builder.addCase(getGradeKelas.fulfilled, (state, action) => {
      console.log("loaded", action.payload.data)
      console.log("Full filled Kelas", action.payload.data)
      state.statusIdKelas = 'loaded'
      state.kelas = action.payload.data
      state.params = action.payload.params
    })
     // Siswa List
     builder.addCase(getSiswaList.pending, (state) => {
      console.log("loading here")
      state.statusSiswa = 'loading'
    })
    builder.addCase(getSiswaList.fulfilled, (state, action) => {
      console.log("loaded here")
      state.statusSiswa = 'loaded'
      state.siswa = action.payload.data
    })
    builder.addCase(getSiswaList.rejected, (state, action) => {
      state.statusSiswa = 'failed'
      state.siswa = action.error
    })
    
  }
})

export const { selectIdKelas, selectKodeGrade} = appLaporanSlice.actions

export default appLaporanSlice.reducer
